import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ProjectsService } from '../../services/projects.service';
import { RouterUrls } from '../../shared/router-urls';
import { LanguageService } from '../../services/language.service';
import { SubscriptionDialogComponent } from '../../your-impact-module/your-impact/subscription-dialog/subscription-dialog.component';

@Component({
  selector: 'app-vote-confirmation-dialog',
  templateUrl: './vote-confirmation-dialog.component.html',
  styleUrls: ['./vote-confirmation-dialog.component.scss']
})
export class VoteConfirmationDialogComponent implements OnInit {

  hasSubs: boolean;
  isPledge: boolean;
  votesLeft: number;
  projectId: string;
  companyName = 'company_name';
  RouterUrls = RouterUrls;

  constructor(private dialogRef: MatDialogRef<VoteConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private projectsService: ProjectsService,
              private languageService: LanguageService,
              private dialog: MatDialog,
              private router: Router) {
    this.hasSubs = data.hasSubs;
    this.isPledge = data.isPledge;
    this.projectId = data.projectId;
  }

  ngOnInit(): void {
    this.projectsService.getVotesLeft().subscribe(value => this.votesLeft = value);
    this.projectsService.getClockInfo().subscribe(data => {
      if (data){
        this.companyName = data.company_name;
      }
    });
  }

  closeDialog(parameter?) {
    if (this.votesLeft === 4) {
      this.projectsService.onVoteWithFiveVotesAvailable$.next();
    }
    this.dialogRef.close();
  }

  get currentLang() {
    return this.languageService.getCurrentLangWithSlash();
  }

  openOneTimeDonation() {
    let oneTimeDonation = true;
    if (!this.hasSubs) {
      oneTimeDonation = false;
    }
    this.closeDialog();
    const subscriptiondialogConfig = new MatDialogConfig();
    subscriptiondialogConfig.width = '953px';
    subscriptiondialogConfig.disableClose = true;
    subscriptiondialogConfig.panelClass = 'subscription-dialog';
    subscriptiondialogConfig.maxWidth = '953px';
    subscriptiondialogConfig.closeOnNavigation = true;
    subscriptiondialogConfig.backdropClass = 'backdropBackground';
    subscriptiondialogConfig.data = {
      oneTimeDonation,
      projectId: this.projectId
    };
    this.dialog.open(SubscriptionDialogComponent, subscriptiondialogConfig);
  }
}
